<template lang="pug">
  .notifications
    v-container.pa-0(style="max-width:600px")
      v-layout.my-6(v-if="!isFetching && notifications.length === 0")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption You have no notification
      .items-layout(v-else)
        .list-item.my-2
          v-list.pt-0(three-line dense)
            template(v-for="(item, index) in notifications")
              //- notification-item(:item="n" :key="n.id" @onMarkRead="handleMarkRead" @onDelete="handleDelete" @viewDetails="viewDetails($event)")

              v-list-item.px-0(@click="openNotification(item)")
                v-layout.mx-4(:class="item.read ? 'read-icon' : 'normal-icon'")
                  CashIcon.ma-auto(v-if="item.type == 'transaction_paid'" size="24" :style="{ 'color': item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].info400 }")
                  eva-icon.ma-auto(v-else-if="item.type == 'lead_created'" name="clipboard-outline" width="24" height="24" :fill="item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].info400")
                  .yezza.ma-auto(v-else)
                    v-img(v-if="item.read" :src="require('@/assets/images/icon_notification_yezza_read.svg')" width="16")
                    v-img(v-else :src="require('@/assets/images/icon_notification_yezza_normal.svg')" width="16")
                v-list-item-content(v-if="item.type == 'default'")
                  v-list-item-subtitle.s1.mr-3(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic800 }" v-html="item.title")
                  v-list-item-subtitle.c1(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic600 }") {{ item.created | convertToHumanizeTime }}
                v-list-item-content(v-else)
                  v-list-item-title.s1.mr-3(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic800 }" v-html="item.title") {{ item.title }}
                  v-list-item-subtitle.c1(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic600 }" v-html="item.body")
                  v-list-item-subtitle.c1(:style="{'color' : item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].basic600 }") {{ item.created | convertToHumanizeTime }}
                v-list-item-action(v-if="!item.read || item.type !== 'default'")
                  v-menu(bottom :offset-x='false' :offset-y='true')
                    template(v-slot:activator='{ on }')
                      v-btn.elevation-0.pa-0.mt-3.mr-3(text color="transparent" min-width="auto" :ripple="false" x-small light v-on='on')
                        eva-icon(name="more-vertical" :fill=" item.read ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500" height="25" width="25" )
                    v-list.pa-0
                      v-list-item.border-bottom(v-if="!item.read" @click="handleMarkRead(item.id)")
                        v-list-item-content
                          v-list-item-title.s2.basic800--text Mark Read
                      v-list-item.border-bottom(v-if="item.type !== 'default'" @click="handleDelete(item.id)")
                        v-list-item-content
                          v-list-item-title.s2.basic800--text Delete


              v-divider.basic300(v-if="index !== notifications.length - 1")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(indeterminate color="primary" :width="2" :size="50")
          v-card.white(height="1px" v-intersect="infiniteScrolling")

    y-dialog(fill-height fluid v-model="showDetails" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.h6.basic800--text(style="height:56px;") {{ detailItem.title }}
        v-card-text(v-html="detailItem.body")
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click="closeDetails") Close
</template>

<script>
import NotificationItem from '@/components/NotificationItem'

export default {
  name: 'Notifications',
  components: { NotificationItem },
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    isFetching: false,
    detailItem: {},
    showDetails: false,
    notifications: [],
    hasNext: true,
    page: 1
  }),
  computed: {
  },
  watch: {
  },
  mounted () {
    this.fetchNext()
    if (this.$route.query.id) {
      this.fetchDetails(this.$route.query.id)
    }
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.fetchNext()
      }
    },
    fetchNext () {
      if (this.isFetching || !this.hasNext) {
        return
      }
      this.isFetching = true
      let params =  {
        page: this.page,
      }
      this.$axios.get('/notifications/partner_commission', { params }).then(resp => {
        this.notifications = this.notifications.concat(resp.data.results)
        this.hasNext = resp.data.next !== null
        this.page++
      }).finally(() => {
        this.isFetching = false
      })
    },
    fetchDetails (itemId) {
      this.$axios.get(`/notifications/partner_commission/${itemId}/`).then(resp => {
        this.viewDetails(resp.data)
      })
    },
    viewDetails (item) {
      this.detailItem = item
      this.showDetails = true
    },
    closeDetails () {
      this.showDetails = false
    },
    handleMarkRead (itemId) {
      this.$set(this.notifications.filter(n => n.id === itemId)[0], 'read', true)
      this.$axios.patch(`/notifications/partner_commission/${itemId}`, { read: true })
    },
    handleDelete (itemId) {
      this.$delete(this.notifications, this.notifications.findIndex(n => n.id === itemId))
      this.$axios.delete(`/notifications/partner_commission/${itemId}`)
    },
    openNotification (item) {
      this.handleMarkRead(item.id)
      this.viewDetails(item)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
.read-icon {
  height: 44px;
  max-width: 44px;
  min-width: 44px;
  border: 2px solid var(--v-textColorDisabled);
  border-radius:  22px;
}
.normal-icon {
  height: 44px;
  max-width: 44px;
  min-width: 44px;
  border: 2px solid var(--v-info400);
  border-radius:  22px;
}
</style>